import React, { useContext, useState } from "react";
import api from "axios_interceptor/interceptor";
import {
  Box,
  Card,
  Inset,
  AspectRatio,
  Flex,
  IconButton,
  DropdownMenu,
  Button,
  Spinner,
  AlertDialog,
  Text,
} from "@radix-ui/themes";
import { CurrentlyPlayingContext } from "context/CurrentlyPlayingContext";
import { YourGeneratedPodcastContext } from "context/LibraryYourGeneratedPodcastContext";

const CoverCard = ({
  focusable,
  title,
  caption,
  cover,
  color,
  audioFileUrl,
  id,
}) => {
  const { setCurrentlyPlaying } = useContext(CurrentlyPlayingContext);
  const { setCurrentYourGeneratedPodcast } = useContext(
    YourGeneratedPodcastContext
  );

  const [loading, setLoading] = useState(false);

  const handlePlayAudio = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/utils/audio-file/${audioFileUrl}`);

      setCurrentlyPlaying({
        title: title,
        artist: caption,
        cover: cover,
        url: `${process.env.REACT_APP_BE_URL}/utils/audio-file/${audioFileUrl}`,
      });
    } catch (error) {
      console.error("Error fetching audio:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchMyGeneratedPodcasts = async () => {
    try {
      const response = await api.post("/utils/audio-check-by-user", {});
      const audioQueue = response.data.content;
      setCurrentYourGeneratedPodcast(audioQueue);
    } catch (error) {
      console.error("Error fetching audio status:", error);
    }
  };

  const handleDelete = async (audioId) => {
    try {
      const response = await api.post(`/utils/audio-delete`, null, {
        params: { audio_id: audioId },
      });

      if (response.status === 200) {
        setCurrentlyPlaying(null);
        fetchMyGeneratedPodcasts();
      }
    } catch (error) {
      console.error("Error deleting audio:", error);
    }
  };

  return (
    <Box p="3" m="-3">
      <Box mb="2" position="relative">
        <Card
          style={{
            boxShadow: `0 8px 48px -16px ${color.replace("%)", "%, 0.6)")}`,
          }}
        >
          <Inset>
            <AspectRatio ratio={1} style={{ position: "relative" }}>
              {loading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 10,
                    borderRadius: "inherit",
                  }}
                >
                  <Spinner />
                </div>
              )}
              <img
                src={cover}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                alt="coverCard"
              />
            </AspectRatio>
          </Inset>
        </Card>

        <Flex gap="2" position="absolute" top="0" right="0" m="2">
          <DropdownMenu.Root>
            <DropdownMenu.Trigger>
              <Button variant="soft" style={{ cursor: "pointer" }}>
                <DropdownMenu.TriggerIcon />
              </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content>
              <DropdownMenu.Item
                color="red"
                onClick={() => handleDelete(id)}
                style={{ cursor: "pointer" }}
              >
                Delete
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        </Flex>

        <Flex gap="2" position="absolute" bottom="0" right="0" m="2">
          <IconButton
            tabIndex={-1}
            radius="full"
            size="3"
            onClick={handlePlayAudio}
            style={{ cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentcolor"
              viewBox="0 0 30 30"
              width="20"
              height="20"
              style={{ marginRight: -2 }}
            >
              <path d="M 6 3 A 1 1 0 0 0 5 4 A 1 1 0 0 0 5 4.0039062 L 5 15 L 5 25.996094 A 1 1 0 0 0 5 26 A 1 1 0 0 0 6 27 A 1 1 0 0 0 6.5800781 26.8125 L 6.5820312 26.814453 L 26.416016 15.908203 A 1 1 0 0 0 27 15 A 1 1 0 0 0 26.388672 14.078125 L 6.5820312 3.1855469 L 6.5800781 3.1855469 A 1 1 0 0 0 6 3 z" />
            </svg>
          </IconButton>
        </Flex>
      </Box>

      <Flex direction="column" position="relative" align="start">
        <AlertDialog.Root>
          <AlertDialog.Trigger>
            <Text style={{ cursor: "pointer" }} size="3">
              {title.length > 50 ? `${title.substring(0, 50)}...` : title}
            </Text>
          </AlertDialog.Trigger>
          <AlertDialog.Content maxWidth="450px">
            <AlertDialog.Title>Full title</AlertDialog.Title>
            <AlertDialog.Description size="4">{title}</AlertDialog.Description>

            <Flex gap="3" mt="4" justify="end">
              <AlertDialog.Action>
                <Button
                  variant="soft"
                  color="green"
                  style={{ cursor: "pointer" }}
                >
                  Ok
                </Button>
              </AlertDialog.Action>
            </Flex>
          </AlertDialog.Content>
        </AlertDialog.Root>
      </Flex>
    </Box>
  );
};

export default CoverCard;
